/** @jsxImportSource @emotion/react */
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import { useTocScrollSpy } from '../hooks/useTocScrollSpy'
import {
  childLinkActive,
  childLinkInactive,
  childLinkRow,
  childList,
  h3Reset,
  linkActive,
  linkInactive,
  linkRow,
  navWidth,
  outer,
  rail,
  rootList,
  titleCss,
  truncateText,
} from './GuideTableOfContents.style'

export type TocItem = {
  id: string
  title: string
  children: Array<{ id: string; title: string }>
}

type Props = {
  tableOfContents?: TocItem[]
  className?: string
}

export function GuideTableOfContents({ tableOfContents = [], className }: Props) {
  const { toc, isActive, onTocClick } = useTocScrollSpy(tableOfContents, { topOffset: 100 })

  if (toc.length === 0) return null

  return (
    <Box css={outer} className={className}>
      <nav aria-labelledby="on-this-page-title" css={navWidth}>
        <Typography id="on-this-page-title" css={titleCss} component="h2">
          In this article
        </Typography>

        <Box css={rail}>
          <Box component="ol" role="list" css={rootList}>
            {toc.map((section) => (
              <Box component="li" key={section.id}>
                <Typography component="h3" css={h3Reset}>
                  <Link
                    to={`#${section.id}`}
                    onClick={(e) => onTocClick(e, section.id)}
                    aria-current={isActive(section) ? 'true' : undefined}
                    css={[linkRow, isActive(section) ? linkActive : linkInactive]}
                  >
                    <span css={truncateText}>{section.title}</span>
                  </Link>
                </Typography>

                {section.children.length > 0 && (
                  <Box component="ol" role="list" css={childList}>
                    {section.children.map((sub) => (
                      <Box component="li" key={sub.id}>
                        <Link
                          to={`#${sub.id}`}
                          onClick={(e) => onTocClick(e, sub.id)}
                          aria-current={isActive(sub) ? 'true' : undefined}
                          css={[childLinkRow, isActive(sub) ? childLinkActive : childLinkInactive]}
                        >
                          <span css={truncateText}>{sub.title}</span>
                        </Link>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </nav>
    </Box>
  )
}
